import React from "react";
import { useFela } from "react-fela";

import { useTheme } from "@/hooks/useTheme";
import { Grid } from "@/components/Grid";
import { Heading } from "@/components/Heading";
import { Accordion } from "@/components/Accordion";

import { IConverterFaqSection } from "./types";

// Trans placeholders like <0>…</0> must not leak into structured data
const stripTransTags = (value: string): string =>
  value.replace(/<\/?\d+>/g, "");

export const ConverterFaqSection: React.FC<IConverterFaqSection> = ({
  title,
  items,
}) => {
  const { bp, colors } = useTheme();
  const { css } = useFela();

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map(item => ({
      "@type": "Question",
      name: stripTransTags(item.question),
      acceptedAnswer: {
        "@type": "Answer",
        text: stripTransTags(item.answerText),
      },
    })),
  };

  const half = Math.ceil(items.length / 2);
  const columns = [items.slice(0, half), items.slice(half)];

  return (
    <Grid
      customStyle={{
        flexDirection: "column",
        [bp.FROM_DESKTOP]: {
          padding: "56px 20px 36px",
        },
      }}
      id="ConverterFaqSection"
    >
      <script
        type="application/ld+json"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <Heading
        as="h2"
        customStyle={{ color: colors.CHARCOAL, textAlign: "center" }}
      >
        {title}
      </Heading>
      <div
        className={css({
          display: "flex",
          flexDirection: "column",
          [bp.FROM_TABLET]: {
            flexDirection: "row",
          },
        })}
      >
        {columns.map((column, columnIndex) => (
          <div
            // eslint-disable-next-line react/no-array-index-key
            key={columnIndex}
            className={css({
              width: "100%",
              [bp.FROM_TABLET]: {
                width: "calc(50% - 21px)",
                display: "inline-block",
                marginRight: columnIndex === 0 ? 21 : 0,
              },
            })}
          >
            {column.map(item => (
              <Accordion
                key={item.question}
                title={item.question}
                longAnswer={item.answer}
                icon={item.icon}
              />
            ))}
          </div>
        ))}
      </div>
    </Grid>
  );
};
